import React from 'react';
import './SquareIcon.scss';

interface SquareIconProps {
  onClick: React.MouseEventHandler<HTMLSpanElement>;
  src: any;
}

export const SquareIcon: React.FC<SquareIconProps> = ({ onClick, src }) => (
  <span className="square-icon-container cursor-pointer" onClick={onClick}>
    <img src={src} alt="squareIcon" />
  </span>
);
